import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import storageSession from 'redux-persist/lib/storage/session';

import snackbarReducer from './snackbar.js';
import namePropertyReducer from './nameProperty.js';
import typePropertyReducer from './typeProperty.js';
import userPermissionsReducer from './userPermissions.js';
import nameUserReducer from './nameUser.js';
import authReducer from './authenticated.js';
import disableReducer from './disable.js';
import notIsFirstAccessReducer from './notIsFirstAccess.js';
import loadingReducer from './loading.js';
import graph1Reducer from './graph1.js';
import graph2Reducer from './graph2.js';
import graph3Reducer from './graph3.js';
import openProgress from './openProgress.js';
import idReducer from './id.js';
import selectedCycleReducer from './selectedCycle.js';
import physicalPondsReducer from './physicalPondsDuck.js';
import userStepsReducer from './userSteps.js';
import filterDashboardReducer from './filterDashboard/reducer.js';
import userPermissionsDomainReducer from './userPermissionsDomain/reducer.js';
import permissionNewUserReducer from './permissionNewUser/reducer.js';
import permissionUserSelectReducer from './permissionUserSelect/reducer.js';
import nurseriesSlice from 'v2/store/nurseries/slice';
import cyclesSlice from 'v2/store/cycles/slice';
import dashboardSlice from 'v2/store/dashboard/slice';
import dataChatSlice from 'v2/store/dataChat/slice';
import toastSlice from 'v2/store/toast/slice';
import cyclesCodeSlice from 'v2/store/cyclesCode/slice';

import thunk from 'redux-thunk';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  nameProperty: namePropertyReducer,
  nameUser: nameUserReducer,
  authenticated: authReducer,
  disable: disableReducer,
  notIsFirstAccess: notIsFirstAccessReducer,
  loading: loadingReducer,
  graph1: graph1Reducer,
  graph2: graph2Reducer,
  graph3: graph3Reducer,
  openProgress,
  id: idReducer,
  selectedCycle: selectedCycleReducer,
  typeProperty: typePropertyReducer,
  userPermissions: userPermissionsReducer,
  physicalPonds: physicalPondsReducer,
  userSteps: userStepsReducer,
  filterDashboard: filterDashboardReducer,
  userPermissionsDomain: userPermissionsDomainReducer,
  permissionNewUser: permissionNewUserReducer,
  permissionUserSelect: permissionUserSelectReducer,
  nurseries: nurseriesSlice,
  cycles: cyclesSlice,
  dashboard: dashboardSlice,
  dataChat: dataChatSlice,
  toast: toastSlice,
  cyclesCodeSlice: cyclesCodeSlice,
});

const persistConfig = {
  key: 'root',
  storage: storageSession,
};
const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});
export const persistor = persistStore(store);
